var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 276,
    viewBox: "0 0 467 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_68_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.9543 9.95431 1 21 1H446C457.046 1 466 9.9543 466 21V255C466 266.046 457.046 275 446 275H21C9.95431 275 1 266.046 1 255V21Z",
    fill: "url(#paint0_linear_68_4)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.9543 9.95431 1 21 1H446C457.046 1 466 9.9543 466 21V255C466 266.046 457.046 275 446 275H21C9.95431 275 1 266.046 1 255V21Z",
    stroke: "url(#paint1_linear_68_4)",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_68_4",
    x: -30,
    y: -30,
    width: 527,
    height: 336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_68_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_68_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_4",
    x1: 236.591,
    y1: 151,
    x2: 254.206,
    y2: 327.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_4",
    x1: 662.681,
    y1: 244.244,
    x2: 116.137,
    y2: -181.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallbox);
export default __webpack_public_path__ + "static/media/small box.bd7d66f14d59a490cacb33e8ccffa9bf.svg";
export { ForwardRef as ReactComponent };